import React from "react";
import { Link } from "react-router-dom";

function Sidebar() {
    // var yocAppOptions = { "colors": { "state": { "brand": "#34bfa3", "light": "#ffffff", "dark": "#282a3c", "primary": "#5867dd", "success": "#34bfa3", "info": "#36a3f7", "warning": "#ffb822", "danger": "#fd3995" }, "base": { "label": ["#c5cbe3", "#a1a8c3", "#3d4465", "#3e4466"], "shape": ["#f0f3ff", "#d9dffa", "#afb4d4", "#646c9a"] } } };
    return (
        <>
            <div
                className="yoc-aside  yoc-aside--fixed  yoc-grid__item yoc-grid yoc-grid--desyocop yoc-grid--hor-desyocop"
                id="yoc_aside"
            >
                <div
                    className="yoc-aside__brand yoc-grid__item "
                    id="yoc_aside_brand"
                    style={{ display: "ruby" }}
                >
                    <div className="logo">
                        <a href="#">
                            <img
                                alt="Logo"
                                src="assets/media/logos/logo-sqare.svg"
                                className="squre-logo"
                            />
                        </a>
                    </div>{" "}
                    <div className="yoc-aside__brand-logo align-items-center">
                        <a href="#">
                            <h5 className="animate-charcter"> Questopedia</h5>
                        </a>
                    </div>
                </div>

                <div
                    className="yoc-aside-menu-wrapper yoc-grid__item yoc-grid__item--fluid"
                    id="yoc_aside_menu_wrapper"
                >
                    <div
                        id="yoc_aside_menu"
                        className="yoc-aside-menu  yoc-aside-menu--dropdown "
                        data-yocmenu-vertical="1"
                        data-yocmenu-dropdown="1"
                        data-yocmenu-scroll="0"
                    >
                        <ul className="yoc-menu__nav ">
                            <li
                                className="yoc-menu__item yoc-menu__item--submenu"
                                id="home"
                                aria-haspopup="true"
                            >
                                <Link to="/dashboard" className="yoc-menu__link ">
                                    <i className="yoc-menu__link-icon flaticon2-analytics-2 "></i>
                                    <span className="yoc-menu__link-text">Dashboard</span>
                                </Link>
                            </li>
                            <li
                                className="yoc-menu__item yoc-menu__item--submenu"
                                aria-haspopup="true"
                                id="Question_bank"
                                data-yocmenu-submenu-toggle="hover"
                            >
                                <a
                                    href="javascript:;"
                                    className="yoc-menu__link yoc-menu__toggle"
                                >
                                    <i className="yoc-menu__link-icon flaticon2-layers-1"></i>
                                    <span className="yoc-menu__link-text">Question Bank</span>
                                </a>
                                <div className="yoc-menu__submenu ">
                                    <span className="yoc-menu__arrow"></span>
                                    <ul className="yoc-menu__subnav">
                                        <li
                                            className="yoc-menu__item  yoc-menu__item--parent"
                                            aria-haspopup="true"
                                        >
                                            <span className="yoc-menu__link">
                                                <span className="yoc-menu__link-text text-white">
                                                    Question Bank
                                                </span>
                                            </span>
                                        </li>
                                        <li className="yoc-menu__item " aria-haspopup="true">
                                            <a href="#" className="yoc-menu__link ">
                                                <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">
                                                    <span></span>
                                                </i>
                                                <span className="yoc-menu__link-text">
                                                    Upload Questions
                                                </span>
                                            </a>
                                        </li>
                                        <li className="yoc-menu__item " aria-haspopup="true">
                                            <a href="#" className="yoc-menu__link ">
                                                <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">
                                                    <span></span>
                                                </i>
                                                <span className="yoc-menu__link-text">
                                                    Manage Questions
                                                </span>
                                            </a>
                                        </li>
                                        <li className="yoc-menu__item " aria-haspopup="true">
                                            <a href="#" className="yoc-menu__link ">
                                                <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">
                                                    <span></span>
                                                </i>
                                                <span className="yoc-menu__link-text">
                                                    Duplicacy Checker
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li
                                className="yoc-menu__item  yoc-menu__item--submenu"
                                aria-haspopup="true"
                                id="Question_paper"
                                data-yocmenu-submenu-toggle="hover"
                            >
                                <a
                                    href="javascript:;"
                                    className="yoc-menu__link yoc-menu__toggle"
                                >
                                    <i className="yoc-menu__link-icon flaticon2-browser-2 "></i>
                                    <span className="yoc-menu__link-text">Question Paper</span>
                                </a>
                                <div className="yoc-menu__submenu ">
                                    <span className="yoc-menu__arrow"></span>
                                    <ul className="yoc-menu__subnav">
                                        <li
                                            className="yoc-menu__item  yoc-menu__item--parent"
                                            aria-haspopup="true"
                                        >
                                            <span className="yoc-menu__link">
                                                <span className="yoc-menu__link-text text-white">
                                                    Question Paper
                                                </span>
                                            </span>
                                        </li>

                                        <li className="yoc-menu__item " aria-haspopup="true">
                                            <a href="#" className="yoc-menu__link ">
                                                <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">
                                                    <span></span>
                                                </i>
                                                <span className="yoc-menu__link-text">
                                                    Paper Manager
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li
                                className="yoc-menu__item  yoc-menu__item--submenu"
                                aria-haspopup="true"
                                id="settings"
                                data-yocmenu-submenu-toggle="hover"
                            >
                                <a
                                    href="javascript:;"
                                    className="yoc-menu__link yoc-menu__toggle"
                                >
                                    <i className="yoc-menu__link-icon flaticon2-gear"></i>
                                    <span className="yoc-menu__link-text">Settings </span>
                                </a>
                                <div className="yoc-menu__submenu ">
                                    <span className="yoc-menu__arrow"></span>
                                    <ul className="yoc-menu__subnav">
                                        <li
                                            className="yoc-menu__item  yoc-menu__item--parent"
                                            aria-haspopup="true"
                                        >
                                            <span className="yoc-menu__link">
                                                <span className="yoc-menu__link-text text-white">
                                                    Settings
                                                </span>
                                            </span>
                                        </li>
                                        <li className="yoc-menu__item " aria-haspopup="true">
                                            {/*<a href="/master-settings" className="yoc-menu__link ">*/}
                                            {/*    <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">*/}
                                            {/*        <span></span>*/}
                                            {/*    </i>*/}
                                            {/*    <span className="yoc-menu__link-text">*/}
                                            {/*        Master Settings*/}
                                            {/*    </span>*/}
                                            {/*</a>*/}
                                            <Link to="/master-settings" className="yoc-menu__link ">
                                                <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">
                                                    <span></span>
                                                </i>
                                                <span className="yoc-menu__link-text">
                                                    Master Settings
                                                </span>
                                            </Link>
                                        </li>
                                        <li className="yoc-menu__item " aria-haspopup="true">
                                            <a href="#" className="yoc-menu__link ">
                                                <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">
                                                    <span></span>
                                                </i>
                                                <span className="yoc-menu__link-text">
                                                    General Settings
                                                </span>
                                            </a>
                                        </li>
                                        <li className="yoc-menu__item " aria-haspopup="true">
                                            <a href="#" className="yoc-menu__link ">
                                                <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">
                                                    <span></span>
                                                </i>
                                                <span className="yoc-menu__link-text">
                                                    Paper Settings
                                                </span>
                                            </a>
                                        </li>
                                        <li className="yoc-menu__item " aria-haspopup="true">
                                            <Link to="/manage-user" className="yoc-menu__link ">
                                                <i className="yoc-menu__link-bullet yoc-menu__link-bullet--line">
                                                    <span></span>
                                                </i>
                                                User Management
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li
                                className="yoc-menu__item "
                                aria-haspopup="true"
                                id="data-analysis"
                            >
                                <a href="d#" className="yoc-menu__link ">
                                    <i className="yoc-menu__link-icon flaticon2-graph"></i>
                                    <span className="yoc-menu__link-text">Data Analysis</span>
                                </a>
                            </li>
                            <li className="yoc-menu__item " aria-haspopup="true" id="help">
                                <a href="#" className="yoc-menu__link ">
                                    <i className="yoc-menu__link-icon flaticon2-help"></i>
                                    <span className="yoc-menu__link-text">Help</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Sidebar;
